module.exports = __webpack_public_path__ + "static/img/alipay.3c0a7c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/alipay.png
// module id = ve28
// module chunks = 4